<template>
  <div class="agreement-grid">
    <agreement-row
      v-if="model.approval"
      class="agreement-row"
      :status="model.approvalStatus"
      :reason="model.approval?.rejectedReason"
      :action="() => {}"
      :action-button-text="'Согласовать'"
      :loading="isLoading"
      :error="errors.getError('approval')"
    >
      <template #icon>
        <img
          v-if="model.approval?.role === USER_ROLE_PARTNER"
          src="@/assets/icons/icon-person.svg"
          alt=""
        />
        <img v-else src="@/assets/icons/icon-bag.svg" alt="" />
      </template>
      <template #labelText>
        {{ model.approvalStatus?.actionLabel }}
      </template>
    </agreement-row>
    <a-divider />
  </div>
</template>

<script setup>
  import ErrorsHandler from '@/components/form/errors-handler';
  import { onMounted, reactive, ref, watch } from 'vue';
  import AgreementRow from '@/components/projects/agreement/AgreementRow.vue';
  import { USER_ROLE_PARTNER } from '@/api/models/UserRole';
  import { getShowcaseVisibleStatusForLeader } from '@/api/models/ProjectShowcaseVisibleStatusLeader';

  const isLoading = ref(false);

  const props = defineProps({
    showcase: {
      type: Object,
      default: null,
    },
  });
  const errors = new ErrorsHandler({ approval: '' });

  const model = reactive({
    showcaseId: null,
    showcaseStatusId: null,
    approval: null,
    approvalStatus: null,
  });

  onMounted(() => {
    fillModel();
  });

  watch(
    () => props.showcase,
    () => {
      fillModel();
    }
  );

  const fillModel = () => {
    if (!props.showcase) return;

    try {
      model.showcaseId = props.showcase.id;
      model.showcaseStatusId = props.showcase.statusId;
      // Если в проекте несколько портфелей, то выбираем первый не пустой approval (у которого есть id)
      const notEmptyApprovals = props.showcase.approvals.filter(
        (el) => !!el.id
      );
      model.approval =
        notEmptyApprovals.length > 0 ? notEmptyApprovals[0] : null;

      model.approvalStatus = model.approval
        ? getShowcaseVisibleStatusForLeader(model.showcaseStatusId)
        : null;
    } catch (error) {
      console.error('error', error);
    }
  };
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors.scss' as *;

  .agreement-grid {
    margin-top: 10px;
    max-width: 902px;

    .agreement-row {
      margin-top: 30px;
    }

    .ant-divider {
      margin-top: 40px;
      margin-bottom: 10px;
    }
  }
</style>
